import { Fragment } from 'react';
import { SearchType, TextKey } from '@mews-commander/enums';
import {
    createValidateSingle,
    InputField,
    InputFieldProps,
    maxInputTextLength,
    SelectField,
    SelectFieldProps,
} from '@mews-commander/legacy-form';
import { Option, Place } from '@mews-commander/types';
import { ResponsiveTwoColumnsFormFields } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import SearchFormField from './SearchFormField';

interface AddressFormFieldsProps {
    onAutocomplete: (place: Place) => void;
    scope: string;
    countryOptions: Option[];
    requiredFields?: {
        country?: boolean;
        addressLine1?: boolean;
        addressLine2?: boolean;
        city?: boolean;
        postalCode?: boolean;
    };
    onChange?: () => void;
}

export const AUTOCOMPLETE_NAME = 'addressAutoComplete';

const locationsProps = {
    label: <LocalizedText textKey={TextKey.AdressAutocomplete} />,
    name: AUTOCOMPLETE_NAME,
    searchType: SearchType.Locations,
};

const addressLine1Props: InputFieldProps = {
    label: <LocalizedText textKey={TextKey.AddressLine1} />,
    name: 'addressLine1',
    validate: createValidateSingle({ length: maxInputTextLength }),
};

const addressLine2Props: InputFieldProps = {
    label: <LocalizedText textKey={TextKey.AddressLine2} />,
    name: 'addressLine2',
    validate: createValidateSingle({ length: maxInputTextLength }),
};

const cityProps: InputFieldProps = {
    label: <LocalizedText textKey={TextKey.City} />,
    name: 'city',
    validate: createValidateSingle({ length: maxInputTextLength }),
};

const postalCodeProps: InputFieldProps = {
    label: <LocalizedText textKey={TextKey.PostalCode} />,
    name: 'postalCode',
    validate: createValidateSingle({ length: maxInputTextLength }),
};

const countryProps: SelectFieldProps = {
    label: <LocalizedText textKey={TextKey.Country} />,
    name: 'countryCode',
    filterable: true,
    options: [],
};

const AddressFormFields = ({ countryOptions, onAutocomplete, scope, requiredFields }: AddressFormFieldsProps) => (
    <Fragment>
        <SearchFormField
            {...locationsProps}
            onResultClick={({ options: place }: $TSFixMe) => onAutocomplete(place)}
            scope={`${scope}-enterprise-form-address`}
            clearOnSelection
        />
        <InputField {...addressLine1Props} required={requiredFields?.addressLine1} />
        <InputField {...addressLine2Props} required={requiredFields?.addressLine2} />
        <ResponsiveTwoColumnsFormFields>
            <InputField {...cityProps} required={requiredFields?.city} />
            <InputField {...postalCodeProps} required={requiredFields?.postalCode} />
        </ResponsiveTwoColumnsFormFields>
        {countryOptions.length > 0 ? (
            <SelectField {...countryProps} options={countryOptions} required={requiredFields?.country} />
        ) : null}
    </Fragment>
);

export default AddressFormFields;
